module.exports = __webpack_public_path__ + "static/media/python.e5a12dfa.svg";